import { css } from "@emotion/css";
import { Fonts } from "@snapchat/snap-design-system";
import React, { type FC } from "react";
import { Flexbox } from "../../../core/components";

const header = css`
    ${Fonts.Heading.H700}
    margin: 5px 0;
`;

const body = css`
    ${Fonts.Paragraph.P300}
`;

const container = css`
    height: 220px;
`;

export const ChartNotice: FC<{ title: string; message: string; icon: React.ReactElement }> = ({
    title,
    message,
    icon,
}) => {
    return (
        <Flexbox flexDirection="column" alignItems="center" justifyContent="center" className={container}>
            {icon}
            <div className={header}>{title}</div>
            <div className={body}>{message}</div>
        </Flexbox>
    );
};
